<template>
	<div v-loading="list_loading">
		<el-table :data="reportList" border style="width: 100%">
			<el-table-column prop="id" label="id">
			</el-table-column>
			<el-table-column prop="breathe" label="呼吸">
			</el-table-column>
			<el-table-column prop="deviceSid" label="设备串号">
			</el-table-column>
			<el-table-column prop="heartRate" label="心跳">
			</el-table-column>
			<el-table-column prop="bodyDynamicValue" label=" 体动值">
			</el-table-column>
			<el-table-column prop="batteryCapacity" label="电池电量">
			</el-table-column>
			<el-table-column prop="bodyStatus" label="身体状态">
			</el-table-column>
			<el-table-column prop="createTime" label="时间">
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="success" @click="handleTime( scope.row)" icon="el-icon-document">报告</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" background @size-change="handleSizeChange" :page-sizes='[5,10,20]' :page-size='pageSize' layout="sizes,prev, pager, next,total,jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				reportList: [],
				total: 0, //总页数
				pageSize: 10, //每页条数
				currentPage: 1, //当前页（默认第一页）
				list_loading:true
			}
		},

		created() {
			this.getReport()
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getReport();
			},
			handleSizeChange(psize) {
				this.pageSize = psize;
				this.getReport();
			},
			getReport() {
				const data = {
					length: this.pageSize,
					start: (this.currentPage - 1) * this.pageSize,
					deviceSid: window.localStorage.getItem("device")
				}
				this.$get("api/showNurseBedList", data).then(res => {
					window.console.log(res)
					this.reportList = res.data
					this.total = res.recordsFiltered
					this.list_loading=false
					this.reportList.map(function(val) {//体动值
						switch(val.bodyDynamicValue){
							case 1:
							val.bodyDynamicValue = "有体动";
							break;
							case 2:
							val.bodyDynamicValue = "无体动";
							break;
						}
						switch(val.bodyStatus){
							case 0:
							val.bodyStatus = "无人";
							break;
							case 1:
							val.bodyStatus = "有人";
							break;
						}
					});

				}).catch((e) => {
					window.console.log(e)
				})
			},
			handleTime(row) {
				window.console.log(row)
				window.sessionStorage.setItem("deviceSid",row.deviceSid)
				window.sessionStorage.setItem("date",row.createTime.split(" ")[0])
				window.sessionStorage.setItem("userId",row.userId)
				let Logistics = this.$router.resolve({
					path: '/report_list',
					query: {
						id:row.id
					}
				})

				window.open(Logistics.href, '_blank');
			}

		}

	}
	//api/nurseBedByDate
</script>

<style scoped="scoped">
	.block {
		text-align: center;
		margin-top: 20px;
	}
</style>
